export default __webpack_public_path__ + "static/media/zainab.135c7759.png";